<template>
  <Newsletter :data="data" />
</template>
<script>
import Newsletter from "../Newsletter.vue";
import data from "./data.json";
import dynamicLocalization from '../../../mixins/dynamic-localization';

export default {
  mixins: [dynamicLocalization],
  components: {
    Newsletter,
  },
  data() {
    return { data }
  }
}
</script>
<i18n src="../i18n.json"/>
